import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.min.css";
import { getBudget } from "@fuse/utils";
import DeleteConfirmation from "./DeleteConfirmation";
import { toast } from "react-toastify";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import {
  AppBar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Icon,
  IconButton,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import { monthsInQuarter } from "date-fns";
import { month } from "ag-charts-community/dist/cjs/es5/util/time";

function roundToTwoDecimal(number) {
  let decimalValue = number.toString().indexOf(".");
  let result = number.toString().substring(decimalValue + 1);
  const data = result.split("");
  if (Number(data[2]) >= 5) {
    return Math.ceil(Number(number) * 100) / 100;
  } else {
    return Number((Math.floor(number * 100) / 100).toFixed(2));
  }
}

const MarketingBudgetList = forwardRef((props, ref) => {
  // const [open, setOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [openCategory, setopenCategory] = useState(false);
  const [openRowDialog, setOpenRowDialog] = useState(false);
  // const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [name, setName] = useState("");
  const [rowName, setRowName] = useState("");
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [childRow, setChildRow] = useState();
  const stateRef = useRef();
  const [stateData, setStateData] = useState({
    filter: "",
    columnState: "",
    columnGroupState: "",
  });
  const gridStateId = useRef();
  const saveGridStateName = props.saveGridStateName;
  let fakeServer;

  const handleClickOpen = (node) => {
    setOpen(true);
    setChildRow(node);
    // if (ref.current.canOpen()) {
    //   setOpen(true);
    // } else {
    //   setShowErrorDialog(true);
    // }
  };

  const handleCategoryClickOpen = () => {
    setopenCategory(true);
  };

  const handleClose = () => {
    setOpen(false);
    setopenCategory(false);
  };

  // const handleCategoryClose = () => {
  //   setopenCategory(false);
  // }

  // const handleErrorDialogClose = () => {
  //   setShowErrorDialog(false);
  // };

  function handleNameChange(event) {
    ref.current.handleNameChange(event);
  }

  // function handleCategoryNameChange(event) {
  //   ref.current.handleCategoryNameChange(event);
  // }

  const getRouteToNode = (rowNode) => {
    if (!rowNode?.parent) {
      return [];
    }
    return [
      ...getRouteToNode(rowNode?.parent),
      rowNode.key ? rowNode.key : rowNode.data.subCategoryName,
    ];
  };

  let latestId = 100000;

  const createFakeServer = (fakeServerData, gridApi) => {
    const getDataAtRoute = (route) => {
      let mutableRoute = [...route];
      let target = { subCategories: fakeServerData };
      while (mutableRoute.length) {
        const nextRoute = mutableRoute[0];
        mutableRoute = mutableRoute.slice(1);
        target = target.subCategories.find(
          (e) => e.subCategoryName === nextRoute
        );
      }
      return target;
    };
    const getBudgetTotal = (budgets, budgetKey = "budgetValues") => {
      return (
        budgets?.[budgetKey].JANUARY +
        budgets?.[budgetKey].FEBRUARY +
        budgets?.[budgetKey].MARCH +
        budgets?.[budgetKey].APRIL +
        budgets?.[budgetKey].MAY +
        budgets?.[budgetKey].JUNE +
        budgets?.[budgetKey].JULY +
        budgets?.[budgetKey].AUGUST +
        budgets?.[budgetKey].SEPTEMBER +
        budgets?.[budgetKey].OCTOBER +
        budgets?.[budgetKey].NOVEMBER +
        budgets?.[budgetKey].DECEMBER
      );
    };
    const sanitizeRowForGrid = (d, index, budgetKey = "budgetValues") => {
      const totalBudget = getBudgetTotal(d.budgets, budgetKey);
      const actualBudget = getBudgetTotal(d.budgets, "actualValues");
      const amount = totalBudget - actualBudget;
      const percentage =
        actualBudget == 0 ? 0 : ((amount / actualBudget) * 100).toFixed();
      return {
        group: !!d.subCategories && !!d.subCategories.length,
        subCategoryId: d.subCategoryId,
        subCategoryName: d.subCategoryName,
        janBudget: d.budgets?.[budgetKey].JANUARY,
        febBudget: d.budgets?.[budgetKey].FEBRUARY,
        marBudget: d.budgets?.[budgetKey].MARCH,
        aprBudget: d.budgets?.[budgetKey].APRIL,
        mayBudget: d.budgets?.[budgetKey].MAY,
        junBudget: d.budgets?.[budgetKey].JUNE,
        julBudget: d.budgets?.[budgetKey].JULY,
        augBudget: d.budgets?.[budgetKey].AUGUST,
        sepBudget: d.budgets?.[budgetKey].SEPTEMBER,
        octBudget: d.budgets?.[budgetKey].OCTOBER,
        novBudget: d.budgets?.[budgetKey].NOVEMBER,
        decBudget: d.budgets?.[budgetKey].DECEMBER,
        total: totalBudget,
        actual: budgetKey === "actualValues" ? undefined : actualBudget,
        amount: amount,
        percentage: `${percentage}%`,
      };
    };
    fakeServer = {
      getData: (request, budgetKey) => {
        function extractRowsFromData(groupKeys, data) {
          if (groupKeys.length === 0) {
            return data.map((item, index) =>
              sanitizeRowForGrid(item, index, budgetKey)
            );
          }
          var key = groupKeys[0];
          for (var i = 0; i < data.length; i++) {
            if (data[i].subCategoryName === key) {
              return extractRowsFromData(
                groupKeys.slice(1),
                data[i].subCategories.slice()
              );
            }
          }
        }
        return extractRowsFromData(request.groupKeys, fakeServerData);
      },
      addChildRow: (route, newRow) => {
        const target = getDataAtRoute(route);
        if (!target.subCategories || target.subCategories.length === 0) {
          target.subCategories = [newRow];
          // update the parent row via transaction
          gridApi.applyServerSideTransaction({
            route: route.slice(0, route.length - 1),
            update: [sanitizeRowForGrid(target)],
          });
        } else {
          target.subCategories.push(newRow);
          // add the child row via transaction
          gridApi.applyServerSideTransaction({
            route,
            add: [sanitizeRowForGrid(newRow)],
          });
        }
      },
      addMainRow: (route, newRow) => {
        const target = getDataAtRoute(route);
        target.subCategories.push(newRow);
        gridApi.applyServerSideTransaction({
          route,
          add: [sanitizeRowForGrid(newRow)],
        });
      },
      removeEmployee: (route) => {
        const target = getDataAtRoute(route);
        const parent = getDataAtRoute(route.slice(0, route.length - 1));
        parent.subCategories = parent.subCategories.filter(
          (child) => child.subCategoryName !== target.subCategoryName
        );
        if (parent.subCategories.length === 0) {
          // update the parent row via transaction, as it's no longer a group
          gridApi.applyServerSideTransaction({
            route: route.slice(0, route.length - 2),
            update: [sanitizeRowForGrid(parent)],
          });
        } else {
          // inform the grid of the changes
          gridApi.applyServerSideTransaction({
            route: route.slice(0, route.length - 1),
            remove: [sanitizeRowForGrid(target)],
          });
        }
      },
    };
    return fakeServer;
  };

  const createServerSideDatasource = (fakeServer, budgetKey) => {
    const dataSource = {
      getRows: (params) => {
        var request = params.request;
        var allRows = fakeServer.getData(request, budgetKey);
        var doingInfinite = request.startRow != null && request.endRow != null;
        var result = doingInfinite
          ? {
              rowData: allRows.slice(request.startRow, request.endRow),
              rowCount: allRows.length,
            }
          : { rowData: allRows };
        params.success(result);
        setTimeout(function () {}, 1000);
      },
    };
    return dataSource;
  };
  const gridRef = useRef();

  function valueSetter(params, field) {
    const { data, newValue, oldValue, node } = params;
    const numberPattern = /^-?[0-9]+(\.[0-9]+)?$/;
    if (numberPattern.test(newValue)) {
      data[field] = roundToTwoDecimal(newValue);
    }

    const parentNode = node?.parent;
    if (!parentNode?.key) return;
    if (parentNode) {
      const parentData = parentNode.data;
      const oldParentValue = parentData[field];
      if (numberPattern.test(newValue) && numberPattern.test(oldParentValue) && numberPattern.test(oldValue)) {
        parentData[field] =roundToTwoDecimal(Number(newValue) + Number(oldParentValue) - Number(oldValue));
      }

      const superParent = parentNode?.parent;
      if (!superParent?.key) return;
      if (superParent) {
        const superParentData = superParent.data;
        const oldSuperParentValue = superParentData[field];
        if (numberPattern.test(newValue) && numberPattern.test(oldSuperParentValue) && numberPattern.test(oldValue)){
          superParentData[field] =roundToTwoDecimal(Number(newValue) + Number(oldSuperParentValue) - Number(oldValue));
        }
      }
    }
  }

  function cellEditingStopped(params) {
    const { oldValue, newValue, api, columnApi, colDef } = params;
    const headerName = params.colDef.headerName;
    const numberPattern = /^-?[0-9]+(\.[0-9]+)?$/;
    const colDefs = columnApi.getColumns().map((col) => col.getColDef());
    const newDefs = colDefs.map((col) => {
      const field = col.field.replace("Budget", "").toLowerCase();
      const currentValue = headerName
        .toLowerCase()
        .replace(`${field} (`, "")
        .replace(")", "");
      if (col.headerName === headerName && numberPattern.test(newValue))
        col.headerName = `${field.toUpperCase()} (${roundToTwoDecimal(
          Number(currentValue) - Number(oldValue) + Number(newValue)
        )})`;
      return col;
    });
    api.setColumnDefs(newDefs);
  }

  const initialColDefs = (budgets, budgetKey = "budgetValues") => {
    const budgetValue = budgets?.[budgetKey];
    return [
      {
        field: "janBudget",
        headerName: `JAN (${roundToTwoDecimal(budgetValue.JANUARY)})`,
        enableRowGroup: true,
        aggFunc: "sum",
        suppressFilter: true,
        minWidth: 80,
        valueSetter: (params) => {
          return valueSetter(params, "janBudget")
        },
      },
      {
        field: "febBudget",
        headerName: `FEB (${roundToTwoDecimal(budgetValue.FEBRUARY)})`,
        enableRowGroup: true,
        aggFunc: "sum",
        minWidth: 80,
        suppressFilter: true,
        valueSetter: (params) => valueSetter(params, "febBudget"),
      },
      {
        field: "marBudget",
        headerName: `MAR (${roundToTwoDecimal(budgetValue.MARCH)})`,
        enableRowGroup: true,
        aggFunc: "sum",
        suppressFilter: true,
        minWidth: 80,
        valueSetter: (params) => valueSetter(params, "marBudget"),
      },
      {
        field: "aprBudget",
        headerName: `APR (${roundToTwoDecimal(budgetValue.APRIL)})`,
        enableRowGroup: true,
        aggFunc: "sum",
        suppressFilter: true,
        minWidth: 80,
        valueSetter: (params) => valueSetter(params, "aprBudget"),
      },
      {
        field: "mayBudget",
        headerName: `MAY (${roundToTwoDecimal(budgetValue.MAY)})`,
        enableRowGroup: true,
        aggFunc: "sum",
        suppressFilter: true,
        minWidth: 80,
        valueSetter: (params) => valueSetter(params, "mayBudget"),
      },
      {
        field: "junBudget",
        headerName: `JUN (${roundToTwoDecimal(budgetValue.JUNE)})`,
        enableRowGroup: true,
        aggFunc: "sum",
        suppressFilter: true,
        minWidth: 80,
        valueSetter: (params) => valueSetter(params, "junBudget"),
      },
      {
        field: "julBudget",
        headerName: `JUL (${roundToTwoDecimal(budgetValue.JULY)})`,
        enableRowGroup: true,
        aggFunc: "sum",
        suppressFilter: true,
        minWidth: 80,
        valueSetter: (params) => valueSetter(params, "julBudget"),
      },
      {
        field: "augBudget",
        headerName: `AUG (${roundToTwoDecimal(budgetValue.AUGUST)})`,
        enableRowGroup: true,
        aggFunc: "sum",
        suppressFilter: true,
        minWidth: 80,
        valueSetter: (params) => valueSetter(params, "augBudget"),
      },
      {
        field: "sepBudget",
        headerName: `SEP (${roundToTwoDecimal(budgetValue.SEPTEMBER)})`,
        enableRowGroup: true,
        aggFunc: "sum",
        suppressFilter: true,
        minWidth: 80,
        valueSetter: (params) => valueSetter(params, "sepBudget"),
      },
      {
        field: "octBudget",
        headerName: `OCT (${roundToTwoDecimal(budgetValue.OCTOBER)})`,
        enableRowGroup: true,
        aggFunc: "sum",
        suppressFilter: true,
        minWidth: 80,
        valueSetter: (params) => valueSetter(params, "octBudget"),
      },
      {
        field: "novBudget",
        headerName: `NOV (${roundToTwoDecimal(budgetValue.NOVEMBER)})`,
        enableRowGroup: true,
        aggFunc: "sum",
        minWidth: 80,
        suppressFilter: true,
        valueSetter: (params) => valueSetter(params, "novBudget"),
      },
      {
        field: "decBudget",
        headerName: `DEC (${roundToTwoDecimal(budgetValue.DECEMBER)})`,
        enableRowGroup: true,
        aggFunc: "sum",
        suppressFilter: true,
        minWidth: 80,
        valueSetter: (params) => valueSetter(params, "decBudget"),
      },
      {
        field: "total",
        headerName: `Total`,
        editable: false,
        minWidth: 100,
        cellStyle: { "background-color": "#FFA726" },
        valueGetter: (params) => {
          let jan = params.getValue("janBudget");
          let feb = params.getValue("febBudget");
          let mar = params.getValue("marBudget");
          let apr = params.getValue("aprBudget");
          let may = params.getValue("mayBudget");
          let jun = params.getValue("junBudget");
          let jul = params.getValue("julBudget");
          let aug = params.getValue("augBudget");
          let sep = params.getValue("sepBudget");
          let oct = params.getValue("octBudget");
          let nov = params.getValue("novBudget");
          let dec = params.getValue("decBudget");
          let result =
            roundToTwoDecimal(jan) +
            roundToTwoDecimal(feb) +
            roundToTwoDecimal(mar) +
            roundToTwoDecimal(apr) +
            roundToTwoDecimal(may) +
            roundToTwoDecimal(jun) +
            roundToTwoDecimal(jul) +
            roundToTwoDecimal(aug) +
            roundToTwoDecimal(sep) +
            roundToTwoDecimal(oct) +
            roundToTwoDecimal(nov) +
            roundToTwoDecimal(dec);
          return result;
        },
        cellRenderer: (params) => {
          return roundToTwoDecimal(params.value);
        },
      },
      {
        field: "actual",
        headerName: `Actual`,
        editable: false,
        minWidth: 100,
        cellStyle: { "background-color": "#F6511D" },
      },
      {
        headerName: `Variation`,
        children: [
          {
            field: "amount",
            headerName: `Amount`,
            cellRenderer: (val) => {
              return roundToTwoDecimal(val.data.amount);
            },
            editable: false,
            minWidth: 120,
            cellStyle: { "background-color": "#6A5837" },
          },
          {
            field: "percentage",
            headerName: `Percentage %`,
            editable: false,
            minWidth: 100,
            cellStyle: { "background-color": "#7FB800" },
          },
        ],
      },
    ];
  };

  const [columnDefs, setColumnDefs] = useState([]);

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      minWidth: 140,
      resizable: true,
      editable: (params) => {
        return !params.data.group;
      }, //params.node.level !== 0
      cellDataType: false,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      sortable: true,
      filterParams: {
        newRowsAction: 'keep'
      }
    };
  }, []);

  const autoGroupColumnDef = useMemo(() => {
    return {
      headerName: "Item Name",
      field: "subCategoryName",
      // editable: false,
      // rowDrag: true,
      filter: "agTextColumnFilter",
      floatingFilter: true,
      sortable: true,
      minWidth: 280,
      // cellRendererParams: {
      //   checkbox: true,
      //   // suppressCount: true,
      // },
      filterParams: {
        treeList: true,
        // excelMode: 'windows',
        // keyCreator: treeDataKeyCreator,
        // values: getEmployeesAsync,
      },
    };
  }, []);

  const isServerSideGroupOpenByDefault = useCallback((params) => {
    var isBrand =
      params.rowNode.level == 0 && params.data.subCategoryName == "BRAND";
    var isMabelWard =
      params.rowNode.level == 1 && params.data.subCategoryName == "DIGITAL";
    return isBrand; //gridRef.current.api.expandAll(); //params.rowNode.level < 1 //isBrand || isMabelWard;
  }, []);

  const getRowId = useMemo(() => {
    return (row) => String(row.data.subCategoryId);
  }, []);

  const isServerSideGroup = useCallback((dataItem) => dataItem.group, []);

  const getServerSideGroupKey = useCallback(
    (dataItem) => dataItem.subCategoryName,
    []
  );

  const onGridReady = useCallback((params) => {
    gridRef.current = params;
    handleData(params);
    // gridRef.current.api.expandAll();
  }, []);

  useEffect(() => {
    if (gridRef.current?.api?.setFilterModel) handleData(gridRef.current);
  }, [props.selectedBudget.value]);

  const handleData = (params) => {
    let data = JSON.parse(JSON.stringify(props.subItem.subCategories));
    const header = initialColDefs(
      props?.subItem?.budgets,
      props?.selectedBudget?.value
    );
    setColumnDefs(header);
    const adjustedData = [...data];
    fakeServer = createFakeServer(adjustedData, params.api);
    var datasource = createServerSideDatasource(
      fakeServer,
      props?.selectedBudget?.value
    );
    if (params.api) params.api.setServerSideDatasource(datasource);
  };

  const createAddress = (tree, payloadData) => {
    let address = "";
    let addressWithoutLastIndex = "";
    let lastIndex = 0;
    let payload = { ...payloadData };
    tree = tree.sort((a, b) => a.level - b.level);
    for (let index = 0; index < tree.length; index++) {
      const element = tree[index];
      const childIndex = payload.subCategories.findIndex(
        (item) => item.subCategoryId === element.id
      );
      lastIndex = childIndex;
      if (childIndex >= 0) {
        address += `subCategories[${childIndex}]`;
        if (index === tree.length - 1) {
          addressWithoutLastIndex += `subCategories`;
        } else {
          addressWithoutLastIndex += `subCategories[${childIndex}]`;
        }
      } else {
        const data = eval(`payload.${address}`);
        if (index < tree.length) {
          address += ".";
          addressWithoutLastIndex += ".";
        }
        const childIndex = data.subCategories.findIndex(
          (item) => item.subCategoryId === element.id
        );
        lastIndex = childIndex;
        if (index === tree.length - 1) {
          addressWithoutLastIndex += `subCategories`;
        } else {
          addressWithoutLastIndex += `subCategories[${childIndex}]`;
        }
        address += `subCategories[${childIndex}]`;
      }
    }
    return { address, lastIndex, addressWithoutLastIndex };
  };

  const createTree = (node) => {
    let tree = [];
    let temp = (item) => {
      tree.push({
        level: item?.level,
        childIndex: item?.rowIndex - item?.level,
        id: item?.data?.subCategoryName,
      });
      if (item.level > 0) {
        temp(item?.parent);
      }
    };
    temp(node);
    return tree;
  };

  const addChildCategoryRow = useCallback(
    (name, node) => {
      const route = getRouteToNode(node);
      let tree = createTree(node);
      let address = createAddress(tree, props.subItem).address;
      let payload = { ...props.subItem };
      tree = tree.sort((a, b) => a.level - b.level);
      const newRow = {
        subCategoryId: name,
        subCategoryName: name,
        budgets: getBudget(),
      };
      let data = eval(`payload.${address}.subCategories`);
      const subCategories = [...data, newRow];
      fakeServer.addChildRow(route, newRow);
      eval(`payload.${address}.subCategories=subCategories`);
      toast.success("Category Added Successfully");
      props.handleUpdate(payload);
      props.handleSave();
    },
    [latestId, fakeServer]
  );

  const addMainCategoryRow = useCallback(
    (name) => {
      const selected = gridRef.current.api.getSelectedNodes();
      const route = getRouteToNode(selected);
      let payload = { ...props.subItem };
      const newRow = {
        subCategoryId: name,
        subCategoryName: name,
        budgets: getBudget(),
      };
      let data = eval(`payload.subCategories`);
      const subCategories = [...data, newRow];
      fakeServer.addMainRow(route, newRow);
      eval(`payload.subCategories=subCategories`);
      toast.success("Category Added Successfully");
      props.handleUpdate(payload);
      props.handleSave();
    },
    [latestId, fakeServer]
  );

  const urlDelete = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.budgetCategories}`;

  const handleDelete = (node) => {
    const selected = node;
    confirmAlert({
      title: "Confirm to submit",
      message: "Are you sure to do this.",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            const route = getRouteToNode(node);
            let tree = createTree(node);
            let address = createAddress(tree, props.subItem).address;
            let payload = { ...props.subItem };
            fakeServer.removeEmployee(route);
            const deleteIndex = createAddress(tree, props.subItem).lastIndex;
            const subCategoryAddress = createAddress(
              tree,
              props.subItem
            ).addressWithoutLastIndex;
            const evelData = eval(`payload.${subCategoryAddress}`);
            const subCategories = evelData.filter(
              (_, index) => index != deleteIndex
            );
            eval(`payload.${subCategoryAddress}=subCategories`);
            toast.success("Category Deleted Successfully");
            props.handleUpdate(payload);
            props.handleSave();
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  const colHide = (show) => {
    gridRef.current.columnApi.setColumnsVisible(
      ["actual", "amount", "percentage"],
      show
    );
  };

  const handleName = (event) => {
    setName(event.target.value);
  };
  const handleCategoryRowName = (event) => {
    setRowName(event.target.value);
  };

  const onBtExport = useCallback(() => {
    const params = {
      fileName: "Marketing_Budget.xlsx",
      sheetName: "Marketing Budget",
    };
    gridRef.current.api.exportDataAsExcel(params);
  }, []);

  useImperativeHandle(ref, () => ({
    // addRow() {
    //   addToSelected(name);
    // },
    handleNameChange(event) {
      handleName(event);
    },
    handleCategoryNameChange(event) {
      handleCategoryRowName(event);
    },
    // deleteRow() {
    //   handleDeleteConfirmation();
    //   //deleteSelected()
    // },
    // addMainRow() {
    //   addRow(name);
    // },
    // addChildRow(){
    //   handleAddChildRow(name)
    // },

    columnHide(show = false) {
      colHide(show);
    },
    // searchRow() {
    //   onFilterChanged()
    // },
    canOpen() {
      const selected = gridRef.current.api.getSelectedNodes()[0];
      return selected;
    },
    exportBtn() {
      onBtExport();
    },
    refreshGrid() {
      gridRef.current.api.forEachNode((node) => {
        node.updateData({ ...node.data, version });
      });
      // if (gridRef.current?.api?.setFilterModel) handleData(gridRef.current);
      // if (gridRef.current?.api) handleData(gridRef.current);
    },
  }));

  function updateParentBudget(jsonData) {
    if (jsonData.subCategories && jsonData.subCategories.length > 0) {
      jsonData.budgets = Object.keys(jsonData.budgets).reduce((acc, key) => {
        acc[key] = Object.keys(jsonData.budgets[key]).reduce(
          (budgetAcc, month) => {
            budgetAcc[month] = jsonData.subCategories.reduce(
              (sum, subCategory) => {
                const childBudget = updateParentBudget(subCategory);
                return (
                  roundToTwoDecimal(sum) +
                  roundToTwoDecimal(childBudget.budgets[key][month])
                );
              },
              0
            );
            return budgetAcc;
          },
          {}
        );
        return acc;
      }, jsonData.budgets);
    }

    return jsonData;
  }

  const onCellValueChanged = (event) => {
    let tree = createTree(event.node);
    let address = createAddress(tree, props.subItem).address; // subCategories[0].subCategories[4]
    let payload = { ...props.subItem };
    let data = eval(`payload.${address}.budgets`); //budgets
    let budgets = [];
    if (props.selectedBudget.value === "budgetValues") {
      budgets = {
        budgetValues: {
          JANUARY: event.data.janBudget,
          FEBRUARY: event.data.febBudget,
          MARCH: event.data.marBudget,
          APRIL: event.data.aprBudget,
          MAY: event.data.mayBudget,
          JUNE: event.data.junBudget,
          JULY: event.data.julBudget,
          AUGUST: event.data.augBudget,
          SEPTEMBER: event.data.sepBudget,
          OCTOBER: event.data.octBudget,
          NOVEMBER: event.data.novBudget,
          DECEMBER: event.data.decBudget,
        },
        forecastValues: {
          ...data.forecastValues,
        },
        actualValues: {
          ...data.actualValues,
        },
      };
    } else if (props.selectedBudget.value === "actualValues") {
      budgets = {
        budgetValues: {
          ...data.budgetValues,
        },
        forecastValues: {
          ...data.forecastValues,
        },
        actualValues: {
          JANUARY: event.data.janBudget,
          FEBRUARY: event.data.febBudget,
          MARCH: event.data.marBudget,
          APRIL: event.data.aprBudget,
          MAY: event.data.mayBudget,
          JUNE: event.data.junBudget,
          JULY: event.data.julBudget,
          AUGUST: event.data.augBudget,
          SEPTEMBER: event.data.sepBudget,
          OCTOBER: event.data.octBudget,
          NOVEMBER: event.data.novBudget,
          DECEMBER: event.data.decBudget,
        },
      };
    } else {
      budgets = {
        budgetValues: {
          ...data.budgetValues,
        },
        forecastValues: {
          JANUARY: event.data.janBudget,
          FEBRUARY: event.data.febBudget,
          MARCH: event.data.marBudget,
          APRIL: event.data.aprBudget,
          MAY: event.data.mayBudget,
          JUNE: event.data.junBudget,
          JULY: event.data.julBudget,
          AUGUST: event.data.augBudget,
          SEPTEMBER: event.data.sepBudget,
          OCTOBER: event.data.octBudget,
          NOVEMBER: event.data.novBudget,
          DECEMBER: event.data.decBudget,
        },
        actualValues: {
          ...data.actualValues,
        },
      };
    }
    data = eval(`payload.${address}.budgets=budgets`);
    const result = updateParentBudget(payload);
    props.handleUpdate(result);
  };

  const getDataPath = useMemo(() => {
    return (data) => data.subCategoryNames;
  }, []);

  const getContextMenuItems = useCallback((params) => {
    var result = [
      {
        name: "Add Main Category",
        action: () => {
          handleCategoryClickOpen();
          //addRow()
        },
      },
      {
        name: "Add Child Category",
        action: () => {
          handleClickOpen(params.node);
        },
      },
      {
        name: "Delete",
        action: () => {
          handleDelete(params.node);
        },
      },
    ];
    return result;
  }, []);

  const onRowEditingStopped = useCallback((event) => {
    console.log("never called - not doing row editing");
  }, []);

  useEffect(() => {
    const saveState = {
      screenName: saveGridStateName,
      screenState: stateData,
    };
    stateRef.current = saveState;
  }, [stateData]);

  const onFilterChanged = (params) => {
    stateData.filter = params?.api?.getFilterModel();
    setStateData(stateData);
  };

  const onColumnStateChanged = (params) => {
    stateData.columnState = params?.columnApi?.getColumnState();
    stateData.columnGroupState = params?.columnApi?.getColumnGroupState();
  };
  const onColumnGroupChange = (params) => {
    onColumnStateChanged(params);
  };

  const onFirstDataLoad = async (params) => {
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.gridState}`;
    const savedState = await OAuthService.getList(
      url + "/fetchState?screenName=" + saveGridStateName
    );
    const data = savedState?.data;

    if (data) {
      gridStateId.current = data?.id;
      data.screenState.filter &&
        params.api.setFilterModel(data?.screenState.filter);
      data.screenState.columnState &&
        params.columnApi.applyColumnState({
          state: data?.screenState?.columnState,
          applyOrder: true,
        });
      data.screenState.columnGroupState &&
        params.columnApi.setColumnGroupState(
          data?.screenState?.columnGroupState
        );
    }
  };

  useEffect(() => {
    return () => {
      const gridState = async () => {
        if (gridStateId.current) {
          try {
            const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.gridStates}`;
            const saveState = await OAuthService.updateData(
              url,
              gridStateId.current,
              stateRef.current
            );
          } catch (error) {
            console.log(error);
          }
        } else {
          try {
            const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.gridState}`;
            const saveState = await OAuthService.addData(
              url + "/saveState",
              stateRef.current
            );
          } catch (error) {
            console.log(error);
          }
        }
      };
      gridState();
    };
  }, []);

  return (
    <>
      <div
        className="ag-theme-alpine-dark"
        style={{ height: 550, width: "100%" }}
      >
        <AgGridReact
          ref={gridRef}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          autoGroupColumnDef={autoGroupColumnDef}
          rowModelType={"serverSide"}
          treeData={true}
          // animateRows={true}
          // cacheBlockSize={10}
          rowSelection={"single"}
          isServerSideGroupOpenByDefault={isServerSideGroupOpenByDefault}
          isServerSideGroup={isServerSideGroup}
          getServerSideGroupKey={getServerSideGroupKey}
          getRowId={getRowId}
          onGridReady={onGridReady}
          onCellValueChanged={onCellValueChanged}
          getDataPath={getDataPath}
          allowContextMenuWithControlKey={true}
          getContextMenuItems={getContextMenuItems}
          onFirstDataRendered={onFirstDataLoad}
          // onFilterChanged={onFilterChanged}
          // onSortChanged={onColumnStateChanged}
          // onColumnVisible={onColumnStateChanged}
          // onColumnPinned={onColumnStateChanged}
          // onColumnResized={onColumnStateChanged}
          // onColumnMoved={onColumnStateChanged}
          // onColumnRowGroupChanged={onColumnGroupChange}
          // enableCellChangeFlash={true}
          onCellEditingStopped={cellEditingStopped}
          // suppressAggFuncInHeader={true}
          // onStoreRefreshed={onStoreRefreshed}
          onRowEditingStopped={onRowEditingStopped}
          headerHeight={28}
          rowHeight={22}
          // undoRedoCellEditing={true}
          // undoRedoCellEditingLimit={10}
          // suppressCopyRowsToClipboard={true}
          // suppressAggFuncInHeader={true}
        ></AgGridReact>
      </div>
      {/* <DeleteConfirmation
        open={deleteDialog}
        handleDeleteClose={handleDeleteClose}
        onYes={deleteSelected}
        title={`Are you sure you want to delete ?`}
        message={`This will delete permanently. You can not undo this action.`}
      /> */}
      <Dialog
        open={open || openCategory}
        onClose={handleClose}
        fullWidth
        maxWidth="xs"
      >
        <AppBar position="static">
          <Toolbar className="flex w-full justify-between">
            <Typography variant="subtitle1" color="inherit">
              Add Your Category Name
            </Typography>
            <IconButton onClick={handleClose}>
              <Icon>close</Icon>
            </IconButton>
          </Toolbar>
        </AppBar>
        <form>
          <DialogContent classes={{ root: "p-16 pb-0 sm:p-24 sm:pb-0" }}>
            <TextField
              id="name"
              label="name"
              className="mt-8 mb-16"
              InputLabelProps={{
                shrink: true,
              }}
              name="name"
              onChange={handleNameChange}
              variant="outlined"
              autoFocus
              required
              fullWidth
            />
          </DialogContent>
          <DialogActions className="float-right px-8 sm:px-16">
            <Button
              onClick={() => {
                if (openCategory) {
                  // ref.current.addMainRow();
                  addMainCategoryRow(name);
                  handleClose();
                  // handleCategoryClose();
                } else {
                  addChildCategoryRow(name, childRow);
                  // ref.current.addRow();
                  handleClose();
                }
              }}
              variant="contained"
              color="primary"
              type="button"
            >
              Add
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      {/* <Dialog
        open={showErrorDialog}
        onClose={handleErrorDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent sx={{ width: '600px', height: 'auto', alignItems: 'center' }}>
          <DialogContentText id="alert-dialog-description" align="center">
            No row was selected.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleErrorDialogClose} autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog> */}
    </>
  );
});

export default MarketingBudgetList;
